import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Manifesting.frontend.types'

@Injectable({ providedIn: 'root' })
export class Manifesting_get_packinglist_contentService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { fileType: string, dataType: string, parameters: any }): Promise<{ error?: string, contentString?: string }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.fileType)) {
      missingRequiredInParams.push('\'fileType\'');
    }
    if (isNil(inParams.dataType)) {
      missingRequiredInParams.push('\'dataType\'');
    }
    if (isNil(inParams.parameters)) {
      missingRequiredInParams.push('\'parameters\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manifesting/functions/get_packinglist_content`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

